import { render, staticRenderFns } from "./UniPager.vue?vue&type=template&id=41d4de92&scoped=true&"
import script from "./UniPager.vue?vue&type=script&lang=js&"
export * from "./UniPager.vue?vue&type=script&lang=js&"
import style0 from "./UniPager.vue?vue&type=style&index=0&id=41d4de92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d4de92",
  null
  
)

export default component.exports